export function buildPlannerTimeOptions(timeOptions, translate) {
  return timeOptions.map(option => ({
    ...option,
    label: option.label.replace('planner.time.minutes', translate('planner.time.minutes'))
  }))
}

export function buildPlannerTimeModes(translate) {
  return [
    { value: 'now', label: translate('planner.timeModes.now') },
    { value: 'departure', label: translate('planner.timeModes.departure') },
    { value: 'arrival', label: translate('planner.timeModes.arrival') }
  ]
}

export function isPlannerDateInvalid(timeModeDate, timeModeHour) {
  return (
    timeModeHour === undefined || timeModeHour === '' || timeModeHour === null
  ) || (
    timeModeDate === undefined || timeModeDate === '' || timeModeDate === null
  )
}

export function isPlannerButtonDisabled(origin, destination, timeMode, invalidDate) {
  return !origin || !destination || (timeMode !== 'now' && invalidDate)
}

export function getSelectedPlannerTimeModeText(timeModes, timeMode, translate) {
  const selectedOption = timeModes.find(option => option.value === timeMode)
  return selectedOption ? selectedOption.label : translate('planner.selectTimeMode')
}

export function buildSelectedPlannerTimeLabel(time, translate) {
  const timeLabel = String(time).replace(/^\+\s+/, '+')
  return `${timeLabel} ${translate('planner.time.minutes')}`
}

export function getPlannerSelectedTimeValue(selectedTime, timeOptions) {
  if (!selectedTime) {
    return undefined
  }

  const normalizedSelectedTime = String(selectedTime).replace(/\s+/g, '')

  const selectedOption = timeOptions.find(option => {
    const normalizedValue = String(option.value).replace(/\s+/g, '')
    const normalizedLabelValue = String(option.label)
      .replace('planner.time.minutes', '')
      .replace(/\s+/g, '')

    return (
      normalizedSelectedTime.startsWith(normalizedValue) ||
      normalizedSelectedTime.startsWith(normalizedLabelValue)
    )
  })

  return selectedOption ? selectedOption.value : undefined
}

export function getSelectedPlannerTimeText(selectedTime, translate) {
  const parsedTime = parseInt(selectedTime, 10)

  if (Number.isNaN(parsedTime)) {
    return translate('planner.selectTime')
  }

  return buildSelectedPlannerTimeLabel(parsedTime, translate)
}
